import { create } from 'zustand';

import { CurrentAcceptance, ManifestBagDto } from './manifestAcceptance';

type State = {
  /** Приёмка, открытая на экране сканирования — по манифесту или без него; null — экран закрыт */
  currentAcceptance: CurrentAcceptance | null;
  bagsData: ManifestBagDto[];
  handleChangeCurrentAcceptance: (acceptance: CurrentAcceptance | null) => void;
  handleChangeBagsData: (bagsData: ManifestBagDto[]) => void;
};

const initialState = {
  currentAcceptance: null,
  bagsData: [],
};

export const useManifestAcceptanceStore = create<State>((set) => ({
  ...initialState,
  handleChangeCurrentAcceptance: (currentAcceptance) => set({ currentAcceptance }),
  handleChangeBagsData: (bagsData) => set({ bagsData }),
}));
